import { message } from "antd";
import { create } from "zustand";

// Zustand store
export const usePDFStore = create((set, get) => ({
    pdfs: [], // Saqlangan PDF-fayllar
    loadstatus: false,
    setLoadStatus: (status) => set({ loadstatus: status }),
    addPDF: (pdf) =>
        set((state) => ({
            pdfs: [...state.pdfs, pdf],
        })),
    setPDFs: (pdfs) => set({ pdfs }), // Fayllarni biryo'la yuklash
    getPDFsFromIndexedDB: async () => {
        const db = await get().openDatabase();
        const transaction = db.transaction("pdfs", "readonly");
        const store = transaction.objectStore("pdfs");
        return new Promise((resolve) => {
            const request = store.getAll();
            request.onsuccess = () => resolve(request.result);
        });
    },


    getPDFByIdFromIndexedDB: async (id) => {
        const db = await get().openDatabase();
        const transaction = db.transaction("pdfs", "readonly");
        const store = transaction.objectStore("pdfs");

        return new Promise((resolve, reject) => {
            const request = store.get(id);
            request.onsuccess = () => {
                if (request.result) {
                    resolve(request.result);
                } else {
                    reject(new Error(`PDF with id "${id}" not found in IndexedDB`));
                }
            };
            request.onerror = () => {
                reject(new Error("Failed to fetch PDF from IndexedDB"));
            };
        });
    },


    savePDFToIndexedDB: async (id, title, blob, author) => {
        const db = await get().openDatabase();
        const transaction = db.transaction("pdfs", "readwrite");
        const store = transaction.objectStore("pdfs");
        store.put({ id, title, blob, author });
        message.success("PDF muvaffaqiyatli saqlandi");
        get().setLoadStatus(false);
        return transaction.complete;
    },


    deletePDFFromIndexedDB: async (id) => {
        try {
            const db = await get().openDatabase();
            const transaction = db.transaction("pdfs", "readwrite");
            const store = transaction.objectStore("pdfs");
            await store.delete(id);
            message.success("Kitob muvaffaqiyatli o'chirildi");
            set((state) => ({
                pdfs: state.pdfs.filter(pdf => pdf.id !== id)
            }));
        } catch (error) {
            console.error("Kitobni o'chirishda xatolik:", error);
            message.error("Kitobni o'chirishda xatolik yuz berdi");
        }
    },


    openDatabase: () => {
        return new Promise((resolve, reject) => {
            const request = indexedDB.open("PDFLibrary", 1);

            request.onupgradeneeded = (event) => {
                const db = event.target.result;
                if (!db.objectStoreNames.contains("pdfs")) {
                    db.createObjectStore("pdfs", { keyPath: "id" });
                }
            };

            request.onsuccess = (event) => resolve(event.target.result);
            request.onerror = (event) => reject(event.target.error);
        });
    },


    handleDownloadPDF: async (id, title, url, author) => {
        try {
            set({ loadstatus: true });
            
            if (!url) {
                throw new Error("Kitob URL manzili topilmadi");
            }

            const response = await fetch(url, {
                method: 'GET',
                mode: 'cors',
                headers: {
                    'Accept': 'application/pdf'
                }
            });

            if (!response.ok) {
                throw new Error(`Kitobni yuklashda xatolik: ${response.status} ${response.statusText}`);
            }

            const reader = response.body.getReader();
            const contentLength = +response.headers.get('Content-Length');

            let receivedLength = 0;
            const chunks = [];

            while(true) {
                const {done, value} = await reader.read();
                
                if (done) break;
                
                chunks.push(value);
                receivedLength += value.length;
                
                const progress = (receivedLength / contentLength) * 100;
                message.loading({
                    content: `Yuklanmoqda: ${Math.round(progress)}%`,
                    key: 'downloadProgress'
                });
            }

            const blob = new Blob(chunks);
            
            if (blob.size === 0) {
                throw new Error("Kitob fayli bo'sh");
            }

            message.loading({ content: "Saqlanmoqda...", key: 'downloadProgress' });
            await get().savePDFToIndexedDB(id, title, blob, author);
            message.success({ content: "Kitob muvaffaqiyatli yuklandi", key: 'downloadProgress' });
            set({ loadstatus: false });
            return true;

        } catch (error) {
            console.error("PDF yuklab olishda xatolik:", error);
            
            let errorMessage = "Kitobni yuklashda xatolik yuz berdi";
            
            if (error.message.includes("Failed to fetch")) {
                errorMessage = "Internet aloqasi yo'q yoki server javob bermayapti";
            } else if (error.name === "TypeError") {
                errorMessage = "Kitob URL manzili noto'g'ri";
            } else if (error.message.includes("CORS")) {
                errorMessage = "Serverdan ruxsat olishda xatolik";
            }
            
            message.error({ content: errorMessage, key: 'downloadProgress' });
            set({ loadstatus: false });
            throw error;
        }
    },


    handleOpenPDF: (pdf) => {
        const url = URL.createObjectURL(pdf.blob);
        window.open(url, "_blank");
    }

}));
